import { forwardRef } from 'react'

import type { IconButtonProps } from '@tribeplatform/react-ui-kit/Button'
import { IconButton } from '@tribeplatform/react-ui-kit/Button'

type ComposerIconButtonProps = IconButtonProps

/**
 * Square button that contains only an icon
 */
export const ComposerIconButton = forwardRef<
  HTMLButtonElement,
  ComposerIconButtonProps
>(({ icon, className, size = 'lg', ...props }, ref) => (
  <IconButton
    ref={ref}
    size={size}
    variant="secondaryNeutral"
    icon={icon}
    className={className}
    {...props}
  />
))
